// Único punto de verdad para las áreas de atención (cola de destino) de los turnos de
// recepción. Espejo de AREAS_ATENCION_VALIDAS / ATENCION_POR_TIPO en
// TurnoRecepcionService.java — si se agrega o cambia un valor acá, hay que cambiarlo también
// del lado backend.
export const AREAS_ATENCION = [
    { valor: 'RTI', etiqueta: 'RTI', color: '#2563eb', bgColor: '#dbeafe', icono: 'bi-file-earmark-text' },
    { valor: 'LABORAL', etiqueta: 'Área Laboral', color: '#f59e0b', bgColor: '#fef3c7', icono: 'bi-hammer' },
    { valor: 'TRIBUNALES', etiqueta: 'Tribunales', color: '#ec4899', bgColor: '#fce7f3', icono: 'bi-bank' },
    { valor: 'ATENCION_PUBLICO', etiqueta: 'Atención al Público', color: '#059669', bgColor: '#d1fae5', icono: 'bi-people-fill' },
    { valor: 'ANSES', etiqueta: 'ANSES', color: '#8b5cf6', bgColor: '#ede9fe', icono: 'bi-building' },
    { valor: 'COBROS', etiqueta: 'Cobros', color: '#0d9488', bgColor: '#ccfbf1', icono: 'bi-cash-coin' },
];

// Sugerencia de área según el trámite con el que se agendó el turno. Espejo de
// ATENCION_POR_TIPO en TurnoRecepcionService.java.
// Los previsionales van al mostrador, no a RTI: RTI es un área real (como ART) pero no es por
// donde se entra — al cliente lo derivan ahí después, si viene a preguntar algo puntual.
const ATENCION_POR_TIPO_TRAMITE = {
    ART: 'LABORAL',
    ANSES: 'ANSES',
    RTI: 'ATENCION_PUBLICO',
    JUBILACION: 'ATENCION_PUBLICO',
    PENSION: 'ATENCION_PUBLICO',
    REAJUSTE: 'ATENCION_PUBLICO',
    // Ganancias no pasa por ANSES en ningún momento: el único turno posible es para firmar
    // documental, y eso se cubre por mostrador (ver TurnoRecepcionService.java / V221).
    GANANCIAS: 'ATENCION_PUBLICO',
    // Minusvalía entra por mostrador, como RTI/Reajuste/Ganancias (el turno ANSES real se saca
    // después, desde la ficha, con el módulo de turnos ANSES).
    MINUSVALIA: 'ATENCION_PUBLICO',
    // Declaratoria de Herederos es judicial (fuero provincial): nunca pasa por ANSES, entra por
    // mostrador igual que RTI/Reajuste/Ganancias/Minusvalía (ver CLAUDE.md / V233).
    DECLARATORIA_HEREDEROS: 'ATENCION_PUBLICO',
    // El amparo por mora ante ANSES se presenta en el juzgado, no en la UDAI: el cliente entra por
    // mostrador (ver TurnoRecepcionService.java / V239).
    AMPARO: 'ATENCION_PUBLICO',
    // El que viene a pagar va a COBROS y no al mostrador: no es una consulta.
    COBRO: 'COBROS',
    // El turno de Tribunales va al área Tribunales (su cola en la pantalla informativa y su
    // filtro en Atención). Antes caía en el default de ATENCION_PUBLICO.
    TRIBUNALES: 'TRIBUNALES',
    GENERAL: 'ATENCION_PUBLICO',
};

// Deriva el área sugerida a partir del tipo de trámite y la modalidad del turno. Es solo
// un default: el operador confirma o cambia el área al hacer el check-in.
export function derivarAtencion(tipoTramite, modalidad) {
    if (String(modalidad || '').trim().toUpperCase() === 'ANSES') {
        return 'ANSES';
    }
    const tipo = String(tipoTramite || '').trim().toUpperCase();
    return ATENCION_POR_TIPO_TRAMITE[tipo] || 'ATENCION_PUBLICO';
}

export function buscarArea(valor) {
    if (!valor) return null;
    const clave = String(valor).trim().toUpperCase();
    return AREAS_ATENCION.find((a) => a.valor === clave) || null;
}

export function etiquetaArea(valor) {
    const area = buscarArea(valor);
    return area ? area.etiqueta : 'Sin asignar';
}
